<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Camera from '@/components/widgets/camera.vue';

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Camera
  },
  data() {
    return {
      statData: null,

      vehicle: null,
      inspection: null,

      send: {
        modal: false,
        id: null,
        name: null,
      }
    };
  },
  methods: {
    getInspection() {
      this.vehicle = null;
      this.inspection = null;

      api
        .get('vehicles/inspections/' + this.$route.params.id)
        .then((response) => {
          if (response.data.status == 'success') {
            this.vehicle = response.data.vehicle;
            this.inspection = response.data.inspection;
          } else {
            this.$router.push('/vehicles');
          }
        })
        .catch((error) => {
          if (error) {
            this.$router.push('/vehicles');
          }
        })
    },
    showSend(row)
    {
      this.send.modal = false;
      this.send.modal = true;
      this.send.id = row.id;
      this.send.name = row.name;
    },
    hideSend() {
      this.send.modal = false;
      this.send.id = null;
      this.send.name = null;
    }
  },
  mounted() {
    this.getInspection()
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/vehicles">Meus Veículos</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block" v-if="vehicle"><router-link tag="a" :to="'/vehicles/' + vehicle.id">Veículo no. {{ vehicle.id }}</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Vistoria</h3>
        <p></p>
      </div>
    </div>

    <fieldset>
      <legend>Meu Veículo</legend>

      <div class="text-center d-flex justify-content-center align-items-center" v-if="!vehicle">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>

      <div v-else-if="vehicle">
        <template v-if="vehicle.coverage && vehicle.coverage == 'active'">
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.monthly | currency }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">MENSALIDADE</div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">DIA {{ vehicle.date_due }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VENCIMENTO</div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.plate }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">PLACA</div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.city }}/{{ vehicle.state }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">LOCALIDADE</div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.price | currency }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VALOR FIPE</div>
            </div>
            <div class="col-12 col-md-12">
              <h6 class="mb-0">{{ vehicle.brand }} {{ vehicle.model }} {{ vehicle.year }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VEÍCULO</div>
            </div>
          </div>
        </template>
      </div>
    </fieldset>

    <fieldset>
      <legend>Vistoria</legend>
      <div class="row">
        <div class="col-md-6">
          <h6 class="mb-0">{{ inspection.date }}</h6>
          <div class="badge badge-soft-default font-size-13 text-uppercase">Criado em</div>
        </div>
        <div class="col-md-6">
          <h6 class="mb-0" v-if="inspection.status == 'notsent'">Não Enviado</h6>
          <h6 class="mb-0" v-else-if="inspection.status == 'pending'">Aguardando Aprovação</h6>
          <h6 class="mb-0" v-else-if="inspection.status == 'reanalysis'">Reanálise</h6>
          <h6 class="mb-0" v-else-if="inspection.status == 'approved'">Aprovado</h6>
          <h6 class="mb-0" v-else-if="inspection.status == 'repproved'">Reprovado</h6>
          <div class="badge badge-soft-default font-size-13 text-uppercase">Status</div>
        </div>
      </div>
    </fieldset>

    <div class="text-center d-flex justify-content-center align-items-center" v-if="!inspection">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="inspection && inspection.items && inspection.items.length == 0" class="text-center d-flex justify-content-center align-items-center">
      <div>
        nenhum item encontrado
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4" v-for="row in inspection.items" :key="row.index">
          <fieldset>
            <legend>{{ row.name }}</legend>
            <div class="mb-3">
              <span v-if="!row.file" class="badge badge-soft-danger py-2 font-size-13 text-uppercase w-100">Não Enviado</span>
              <span v-else-if="row.file.status == 'pending'" class="badge badge-soft-warning py-2 font-size-13 text-uppercase w-100">Aguardando Aprovação</span>
              <span v-else-if="row.file.status == 'approved'" class="badge badge-soft-success py-2 font-size-13 text-uppercase w-100">Aprovado</span>
              <span v-else-if="row.file.status == 'repproved'" class="badge badge-soft-danger py-2 font-size-13 text-uppercase w-100">Reprovado</span>
            </div>
            <div class="mb-3 text-center">
              <div v-if="row.file && row.file.url" class="text-center">
                <div class="mb-2"><img :src="row.file.url" alt="" class="img-fluid" style="max-height: 250px;"><br></div>
                <div><span class="badge badge-soft-dark font-size-13 text-uppercase">enviado em {{ row.file.date }}</span></div>
              </div>
              <div v-else-if="row.example" class="text-center">
                <div class="mb-2"><img :src="row.example" alt="" class="img-fluid" style="max-height: 250px;"><br></div>
                <div><span class="badge badge-soft-dark font-size-13 text-uppercase">exemplo</span></div>
              </div>
            </div>
            <div>
              <button class="btn btn-default btn-block btn-lg" v-if="!row.file" v-on:click="showSend(row);">Enviar</button>
              <button class="btn btn-default btn-block btn-lg" v-else-if="row.file.status == 'pending'" disabled>Enviar</button>
              <button class="btn btn-default btn-block btn-lg" v-else-if="row.file.status == 'approved'" disabled>Enviar</button>
              <button class="btn btn-default btn-block btn-lg" v-else-if="row.file.status == 'repproved'" v-on:click="showSend(row);">Reenviar</button>
            </div>
          </fieldset>
        </div>
      </div>
    </div>

    <b-modal v-model="send.modal" modal-class="modal-camera modal-right" :title="send.name" hide-footer>
      <div v-if="send.id">
        <Camera :inspection="inspection.id" :item="send.id" />
      </div>
      <div v-else>
        <div class="text-center d-flex justify-content-center align-items-center">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>